import RootStore from "./stores/RootStore";

///<reference types="webpack-env" />
if (module.hot) module.hot.accept();

export { default as history } from "./utils/history";
export * from "./utils/history";
/***
 * should pass this as arguments to consumer not use directly.
 */
export const rootStore = new RootStore();
